export const esQuick = {
  'quick.addAnother': 'Registrar otro gasto',
  'quick.addMovement': 'Agregar como movimiento',
  'quick.afterExpense': 'Después del gasto',
  'quick.amountQuestion': '¿Qué gasto quieres probar?',
  'quick.availableOnDate': 'Disponible ese día',
  'quick.categoryQuestion': '¿En qué fue?',
  'quick.checkImpact': 'Ver impacto',
  'quick.classify': 'Clasificar gasto',
  'quick.completeMovement': 'Completa el movimiento',
  'quick.dateQuestion': '¿En qué fecha?',
  'quick.description':
    'Prueba un gasto futuro sin modificar tu plan; agrégalo sólo si decides hacerlo.',
  'quick.futureLow': 'Punto más bajo después',
  'quick.horizonBalance': 'Saldo global en 6 meses',
  'quick.impact': '¿Tienes capacidad para hacerlo?',
  'quick.impactCritical': 'Este gasto llevaría tu proyección por debajo de cero.',
  'quick.impactFutureRisk':
    'Puedes pagarlo en {wallet}, pero después tu proyección cae bajo cero. Revisa los compromisos futuros.',
  'quick.impactInsufficient':
    '{wallet} no tendría fondos suficientes el {date}. El movimiento todavía no se ha guardado.',
  'quick.impactSafe':
    'Puedes pagarlo con {wallet} y la wallet se mantiene sobre cero durante los próximos seis meses.',
  'quick.notePlaceholder': 'Nota opcional',
  'quick.saved': 'Gasto registrado',
  'quick.savedDescription': 'Tu proyección ya incluye este movimiento.',
  'quick.save': 'Confirmar gasto',
  'quick.sixMonthBalance': 'Saldo en 6 meses',
  'quick.walletQuestion': '¿De cuál wallet salió?',
} as const;

export const enQuick: Record<keyof typeof esQuick, string> = {
  'quick.addAnother': 'Record another expense',
  'quick.addMovement': 'Add as movement',
  'quick.afterExpense': 'After the expense',
  'quick.amountQuestion': 'What expense do you want to test?',
  'quick.availableOnDate': 'Available that day',
  'quick.categoryQuestion': 'What was it for?',
  'quick.checkImpact': 'See impact',
  'quick.classify': 'Classify expense',
  'quick.completeMovement': 'Complete the movement',
  'quick.dateQuestion': 'On what date?',
  'quick.description':
    'Test a future expense without changing your plan; add it only if you choose to.',
  'quick.futureLow': 'Lowest point afterward',
  'quick.horizonBalance': 'Global balance in 6 months',
  'quick.impact': 'Can you afford it?',
  'quick.impactCritical': 'This expense would take your projection below zero.',
  'quick.impactFutureRisk':
    'You can pay it from {wallet}, but your projection later drops below zero. Review future commitments.',
  'quick.impactInsufficient':
    '{wallet} would not have enough funds on {date}. The movement has not been saved.',
  'quick.impactSafe':
    'You can pay it from {wallet}, and the wallet stays above zero for the next six months.',
  'quick.notePlaceholder': 'Optional note',
  'quick.saved': 'Expense recorded',
  'quick.savedDescription': 'Your projection now includes this movement.',
  'quick.save': 'Confirm expense',
  'quick.sixMonthBalance': 'Balance in 6 months',
  'quick.walletQuestion': 'Which wallet paid for it?',
};
